// React import removed as it's not needed with new JSX transform

interface IconProps {
  size?: number;
  stroke?: string;
  fill?: string;
  className?: string;
  title?: string;
}

const icons = {
  dashboard: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M3 13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13 21a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13 3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13 11a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  shield: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'alert-triangle': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="12" y1="9" x2="12" y2="13" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="17" r="1" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'eye': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="3" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  book: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  users: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="9" cy="7" r="4" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'chevron-right': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M9 18l6-6-6-6" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'chevron-down': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M6 9l6 6 6-6" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'arrow-up-right': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <line x1="7" y1="17" x2="17" y2="7" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="7,7 17,7 17,17" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  plus: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <line x1="12" y1="5" x2="12" y2="19" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="5" y1="12" x2="19" y2="12" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  settings: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <circle cx="12" cy="12" r="3" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2 2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  download: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="7,10 12,15 17,10" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="12" y1="15" x2="12" y2="3" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  external: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="15,3 21,3 21,9" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="10" y1="14" x2="21" y2="3" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  calendar: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="16" y1="2" x2="16" y2="6" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="8" y1="2" x2="8" y2="6" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="3" y1="10" x2="21" y2="10" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  tag: (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="7" y1="7" x2="7.01" y2="7" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'bell': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'activity': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'trending-up': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="17,6 23,6 23,12" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'x': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <line x1="18" y1="6" x2="6" y2="18" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="6" y1="6" x2="18" y2="18" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'search': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <circle cx="11" cy="11" r="8" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="m21 21-4.35-4.35" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'filter': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'refresh': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <polyline points="23,4 23,10 17,10" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="1,20 1,14 7,14" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'file-text': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="14,2 14,8 20,8" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="16" y1="13" x2="8" y2="13" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="16" y1="17" x2="8" y2="17" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="10,9 9,9 8,9" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'clock': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <circle cx="12" cy="12" r="10" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="12,6 12,12 16,14" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'git-branch': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <line x1="6" y1="3" x2="6" y2="15" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="18" cy="6" r="3" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="6" cy="18" r="3" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 9a9 9 0 0 1-9 9" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'check': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <polyline points="20,6 9,17 4,12" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'dots': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <circle cx="12" cy="12" r="1" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="19" cy="12" r="1" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="5" cy="12" r="1" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'close': (props: IconProps) => (
    <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" className={props.className}>
      <line x1="18" y1="6" x2="6" y2="18" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="6" y1="6" x2="18" y2="18" stroke={props.stroke || 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

export type IconName = keyof typeof icons;

interface Props extends IconProps {
  name: IconName;
}

export function Icon({ name, title, ...props }: Props) {
  const IconComponent = icons[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  return (
    <div title={title}>
      <IconComponent {...props} />
    </div>
  );
}

export default Icon;